module.exports = __webpack_public_path__ + "img/customerManagement.47cd3f4c.png";